import { render } from "./MyView.vue?vue&type=template&id=5c0ada8a&scoped=true"
import script from "./MyView.vue?vue&type=script&lang=js"
export * from "./MyView.vue?vue&type=script&lang=js"

import "./MyView.vue?vue&type=style&index=0&id=5c0ada8a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0ada8a"]])

export default __exports__